import { routes } from '../routes';

// Where an elementary or sport order package goes once it is in the cart: the
// add-ons page when the school has elementary add-ons to offer, else review.
//
// ONE implementation, shared by the package builder and the group picture page
// (SportsTeamPicture). The page used to go straight to review, so a sport
// parent buying a team or buddy picture never saw the add-ons (2026-10-13).
export default function afterAddRoute({
  hasAddons, favorites, orderPackageId, optionId, packageId,
}) {
  if (!hasAddons) return routes.multiPoseReview(orderPackageId);

  return routes.multiPoseAddons({
    favs: favorites, op: orderPackageId, opt: optionId, package: packageId, isSenior: false,
  });
}
